module.exports = __webpack_public_path__ + "static/media/goldenprize-tuna-oliveoil-lid.85f3ae9c.png";